import React from 'react'
import {Lang} from 'yougile-lang'
import {COLUMN_NAMES_CORRECT as columnNames} from '../constants'

import {
  ColumnDescription,
  ColumnName,
  ColumnStatus,
  ColumnType,
  Row
} from './containers'
import {DescriptionTableRow} from './description-table-row'

type DescriptionTableProps = {
  fileColumnNames: string[]
}

// eslint-disable-next-line max-lines-per-function
export const DescriptionTable = ({fileColumnNames}: DescriptionTableProps) => {
  const lang = Lang.msg.importFromFile

  return (
    <table>
      <Row $isBold>
        <ColumnName>{lang.columnName}</ColumnName>
        <ColumnType>{lang.columnType}</ColumnType>
        <ColumnStatus>{lang.columnStatus}</ColumnStatus>
        <ColumnDescription>{lang.columnDescription}</ColumnDescription>
      </Row>
      <DescriptionTableRow
        title={columnNames.PROJECT}
        description={lang.descriptionOfProject}
        type={lang.columnTypeString}
        fileColumnNames={fileColumnNames}
      />

      <DescriptionTableRow
        title={columnNames.TITLE}
        description={lang.descriptionOfTitle}
        type={lang.columnTypeString}
        fileColumnNames={fileColumnNames}
        required
      />

      <DescriptionTableRow
        title={columnNames.DESCRIPTION}
        description={lang.descriptionOfDescription}
        type={lang.columnTypeString}
        fileColumnNames={fileColumnNames}
      />

      <DescriptionTableRow
        title={columnNames.CREATED_DATE}
        description={lang.descriptionOfCreatedDate}
        type={lang.columnTypeDate}
        fileColumnNames={fileColumnNames}
      />

      <DescriptionTableRow
        title={columnNames.DEADLINE}
        description={lang.descriptionOfDeadline}
        type={lang.columnTypeDate}
        fileColumnNames={fileColumnNames}
      />

      <DescriptionTableRow
        title={columnNames.START_DATE}
        description={lang.descriptionOfStartDate}
        type={lang.columnTypeDate}
        fileColumnNames={fileColumnNames}
      />

      <DescriptionTableRow
        title={columnNames.COMPLETED}
        description={lang.descriptionOfCompleted}
        type={lang.columnTypeDate}
        fileColumnNames={fileColumnNames}
      />

      <DescriptionTableRow
        title={columnNames.ARCHIVED}
        description={lang.descriptionOfArchived}
        type={lang.columnTypeDate}
        fileColumnNames={fileColumnNames}
      />

      <DescriptionTableRow
        title={columnNames.ASSIGNED}
        description={lang.descriptionOfAssigned}
        type={lang.columnTypeEmail}
        fileColumnNames={fileColumnNames}
      />

      <DescriptionTableRow
        title={columnNames.COLUMN}
        description={lang.descriptionOfColumn}
        type={lang.columnTypeString}
        fileColumnNames={fileColumnNames}
      />
      <DescriptionTableRow
        title={columnNames.BOARD}
        description={lang.descriptionOfBoard}
        type={lang.columnTypeString}
        fileColumnNames={fileColumnNames}
      />
      <DescriptionTableRow
        title={columnNames.PARENT_TASK}
        description={lang.descriptionOfParentTask}
        type={lang.columnTypeString}
        fileColumnNames={fileColumnNames}
      />
    </table>
  )
}
